import LSVariables from "../configs/LS_variables.json";
import { Driver } from "../interfaces/drivers.interface";
import { User } from "../interfaces/users.interface";
import { getSavedState, setSavedState } from "../utils/LocalStorage.utils";
import api from "./api";

export class AuthService {
  getUser(): Driver {
    return getSavedState(LSVariables.saved_user);
  }

  setUser(user: Driver) {
    setSavedState(user, LSVariables.saved_user);
  }

  logIn(user: User) {
    return api.post(`/loginDriver`, user);
  }

  logOut() {
    // Clear local storage
    setSavedState(null, LSVariables.saved_user);
    localStorage.removeItem("token");
    
    // Clear auth cookie by setting it to expire immediately
    document.cookie = "Authorization=; Max-age=0; path=/;";
    
    return api.post(`/logout`);
  }
}

export const authService = new AuthService();
